module.exports = __webpack_public_path__ + "img/location_on_FILL0_wght400_GRAD0_opsz48.fc9c127d.svg";